export const NEW_PASSWORD_REQUIRED = 'NEW_PASSWORD_REQUIRED';
const SOFTWARE_TOKEN_MFA = 'SOFTWARE_TOKEN_MFA';
export const SMS_MFA = 'SMS_MFA';
export const MFA_SETUP = 'MFA_SETUP';

export const SUPPORTED_CHALLENGES = new Set([
  NEW_PASSWORD_REQUIRED,
  SOFTWARE_TOKEN_MFA,
  SMS_MFA,
  MFA_SETUP,
]);

// The challenge-response key Cognito expects for the entered MFA code.
export const mfaCodeKey = (challengeName: string) =>
  challengeName === SMS_MFA ? 'SMS_MFA_CODE' : 'SOFTWARE_TOKEN_MFA_CODE';

export interface Challenge {
  session: string;
  email: string;
  challengeName: string;
  challengeParameters?: Record<string, string> | null;
}
